// extracted by mini-css-extract-plugin
export default {"capacity-overview__container":"CapacityOverview_capacity-overview__container__O5pMB"};